module.exports = __webpack_public_path__ + "static/media/intro1.42839c12.gif";